<template lang="pug">
.profile(v-if="data" :class="data?.className")
	.profile__container
		v-loader(:loading="loading" :fullscreen="fullscreenLoader")
		.profile__left
			//component.profile__title.h1(v-if="data.title" :is="data.titleLevel || 'h1'") {{data.title}}
			.profile__info(v-if="data?.user && isSm")
				.profile-info(v-if="data?.user")
					.profile-info__head(v-if="data.user.logo")
						img.profile-info__head-img(:src="data.user.logo.src" :alt="data.user.logo.alt" :class="data.className")
					.profile-info__label(v-if="data.user.name") {{data.user.name}}
					.profile-info__desc(v-if="data.user.desc") {{data.user.desc}}`
			.profile__content
				v-form.profile__form(:data-source="data" ref="form" :fullscreen-loader="fullscreenLoader")
		.profile__right(v-if="data && !isSm")
			.profile-info(v-if="data?.progress")
				.profile-info__progress(v-if="data?.groups" )
					.profile-info__progress-item.flc(v-for="(item, index) in data.groups" :key="index")
						input.field-checkbox__input(
							:type="'checkbox'"
							:checked="checkGroups(item.id)"
							:disabled="!checkGroups(item.id)")
						span.field-checkbox__visual
						span.field-checkbox__text(v-html="item.title" :class="{'checked': checkGroups(item.id)}")
			//- Данные компании (логотип/название/тип/ID) перенесены в левое меню
			//- (v-internal-nav). Колонка оставлена пустой, чтобы не растягивать форму.
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		// Центрировать спиннер сохранения по центру экрана (телепорт в body),
		// а не по центру блока формы. Включается на форме создания объявления,
		// где длинная форма и sticky-лоадер «залипает» вверху при скролле.
		fullscreenLoader: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			data: null,
			timerId: null,
			localFormData: new FormData(),
		}
	},

	computed: {
		computedCheckGroups() {
			let data = {};

			this.data.groups.forEach((group) => {
				data[group.id] = []
				this.data.fields.forEach((field ) => {

					if(group.id === field.groupId) {
						if(String(field.value)) {
							if(Array.isArray(field.value)) {
								if(field.value.length) {
									data[group.id] = [
										...data[group.id],
										{
											id: field.id,
											value: field.value
										}
									]
								}
							} else {
								data[group.id] = [
									...data[group.id],
									{
										id: field.id,
										value: field.value
									}
								]
							}
						}
					}
				})
			})
			return data;
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.setErrors();

		},

		checkGroups(id) {
			const fieldLenght = this.data.fields.filter(field => field.groupId === id && field.groupId).length
			return this.computedCheckGroups[id].length === fieldLenght
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		setErrors() {
			if (this.data?.fields?.length) {
				this.data.fields.forEach((field) => {
					field.errors = this.getFieldError(field)
				})
			}
		},

		fileInput(field, e) {
			this.savedFileKeys = [];
			for (let i = 0; i < e.target.files.length; i++) {
				this.savedFileKeys.push(e.key);
				this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
			}

		},

		sendFormBuilder(action = null) {
			this.requestDataLoad(this.data.remote, action)
		},

		sentForm() {
			this.requestDataLoad(this.data.remote)
		},

		requestDataLoad(remote = this.data.remote, action = null) {
			clearTimeout(this.timerId);

			let namesOfCurrentIteration = [];
			if (this.data && this.data.fields) {
				this.data.fields.forEach(field => {
					let key = this.proxyFieldName(field.name);
					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type === 'file') {
						// очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							let isfoundInSavedFileKeys = false;
							for (let j = 0; j < this.savedFileKeys.length; j++) {
								if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
									isfoundInSavedFileKeys = true;
									break;
								}
							}
							if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
								this.localFormData.delete(item[0]);
							}
						}
					}
					if (namesOfCurrentIteration.indexOf(key) < 0) {
						this.localFormData.delete(key);
						namesOfCurrentIteration.push(key);
					}
					if (field.type === 'file') {
						// обработка файлов происходит в fileInput / fileRemove
						// здесь ничего делать не нужно
						/*
						 _.each(field.value, (fileListItem) => {
						 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
						 });
						 */
					} else {
						// для отправки файлов придется держать в памяти неизменный localFormData
						// перед отправкой нужно удалить старые значения из localFormData
						// т.к. localFormData.append добавляет новые значения к существующим
						// а localFormData.set не позволила бы работать с массивами типа NAME[]
						if (namesOfCurrentIteration.indexOf(key) < 0) {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}
						if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								this.localFormData.append(`${key}[${index}]`, val);
							});
						} else {
							this.localFormData.append(key, field.value);
						}
					}
				});
			}
			// this.localFormData.set('bxajaxid', this.bxajaxid);
			this.localFormData.set('action', action);

			this.timerId = setTimeout(() => {
				
				this.dataLoad({
					url: remote,
					delay: true,
					data: this.localFormData
				}, remote);
			},500)

		},

		getFieldError(field) {
			if (this.data.errors && this.data.errors.fields) {
				let filteredErrors = this.data.errors.fields.filter((item) => item.name === field.name);
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},


	},

	created() {
		controller.events.on('update-form', () => this.$refs['form'].updateForm());
	}

}
</script>
